import useErrorBoundary from 'use-error-boundary';
import * as Sentry from '@sentry/browser'; // eslint-disable-line import/no-namespace
import ErrorDialog from './ErrorDialog';

type ErrorBoundaryProps = {
  children: React.ReactNode;
};

const ErrorBoundary = ({children}: ErrorBoundaryProps) => {
  const {didCatch, ErrorBoundary: UseErrorBoundaryComponent} = useErrorBoundary({
    onDidCatch: (error, errorInfo) => {
      Sentry.withScope(scope => {
        scope.setExtra('errorInfo', errorInfo);
        scope.setExtra('calledFrom', 'errorBoundary');
        Sentry.captureException(error);
      });
    },
  });

  return (
    <>
      {didCatch ? (
        <ErrorDialog />
      ) : (
        <UseErrorBoundaryComponent>
          <>{children}</>
        </UseErrorBoundaryComponent>
      )}
    </>
  );
};

export default ErrorBoundary;
